export default __webpack_public_path__ + "static/media/message_talent_review.43bb0373.svg";